import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hyrelancer_frontend/hyrelancer/src/components/Footer/SimpleFooter.jsx");
;
import(/* webpackMode: "eager" */ "/home/hyrelancer_frontend/hyrelancer/src/styles/globals.css");
